<div class="files-wrapper d-flex flex-wrap">
  <input
    style="display: none"
    type="file"
    accept="application/pdf"
    (change)="onFileChanged($event.target.files)"
    #fileInput
  />
  <div
    (click)="fileInput.click()"
    class="file-item add-item d-flex flex-column align-items-center justify-content-center"
    *ngIf="canAddFile"
  >
    <div class="icon">
      <svg viewBox="0 0 48 53">
        <use href="#new-add-file" />
      </svg>
    </div>
    <div class="title">Add a file</div>
  </div>
  <app-club-media-files-section
    [files]="files?.slice(i * 20, i * 20 + 20)"
    (startLoading)="onStartLoadingFilesSection()"
    (loaded)="onLoadedFilesSection()"
    (remove)="onRemove($event)"
    *ngFor="let i of sections"
  ></app-club-media-files-section>
  <app-loader-2 *ngIf="isLoadingMore"></app-loader-2>
</div>
